import React from "react";
import { JsonSchema } from "../models";
import { AuditDetailsField as AuditDetailsFieldHelper } from "./helpers";
import { ArrayFieldProps, AuditDetailsArrayFieldOptions, AuditDetailsFormData } from "./models";

export const AuditDetailsArrayFieldComponent = (props: ArrayFieldProps<AuditDetailsFormData>) => {
  const { id, schema, formData, uiSchema } = props;

  const options = uiSchema["ui:options"] as AuditDetailsArrayFieldOptions | undefined;

  if (!(options && options.labels)) {
    throw Error("labels must be specified on ui:options property of AuditDetailsArrayField uiSchema.");
  }

  const { labels } = options;

  return (
    <div>
      {formData &&
        formData.map((auditDetails, index) => {
          const auditDetailsSchema = schema.items as JsonSchema;

          return (
            <AuditDetailsFieldHelper
              id={id}
              key={`adfk_${index + 1}`}
              label={labels[index] ? `${labels[index]} ${auditDetailsSchema.title}` : auditDetailsSchema.title}
              at={auditDetails.at}
              userName={auditDetails.userName}
              personName={auditDetails.personName}
            />
          );
        })}
    </div>
  );
};

export const AuditDetailsArrayField = AuditDetailsArrayFieldComponent;
